<template>
  <div
    class="p-my-product__item"
    :title="item.description"
  >
    <img class="p-my-product__item__bg" :src="item.icon" @click="clickItem(item)" />
    <div class="p-my-product__item__content">
      <div>
        <p class="p-my-product__item__title single-omit">{{ item.name }}</p>
        <p class="p-my-product__item__desc multi-omit">{{ item.description }}</p>
      </div>
      <button class="p-my-product__item__btn" @click="clickItem(item)">立即进入</button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      default: () => ({})
    }
  },
  methods: {
    async clickItem(item) {
      this.$emit('click-item', item)
    },
  }
}
</script>

<style lang="scss">
.p-my-product__item {
  display: inline-block;
  height: 0.98rem;
  margin-bottom: 0.55rem;
}
.p-my-product__item__border {
  margin-left: 0.16rem;
  padding-left: 0.43rem;
  border-left: 1px solid #E8E8E8;
}
.p-my-product__item__bg {
  width: 0.98rem;
  height: 0.98rem;
  vertical-align: top;
  margin-right: 0.18rem;
  border-radius: 18px;
  cursor: pointer;
}
.p-my-product__item__content {
  height: 0.98rem;
  display: inline-flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
}
.p-my-product__item__title {
  width: 2.44rem;
  font-size: 0.16rem;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #333333;
  line-height: 0.22rem;
  margin-bottom: 0;
}
.p-my-product__item__desc {
  width: 2.44rem;
  font-size: 0.14rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #666666;
  line-height: 0.22rem;

}
.p-my-product__item__btn {
  cursor: pointer;
  width: 0.86rem;
  height: 0.28rem;
  background: #FFFFFF;
  border-radius: 0.06rem;
  border: 1px solid #257EFE;
  font-size: 0.14rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #257EFE;
  padding: 0;
  outline: none;
  margin-top: -.08rem;
}
.p-my-product__item__btn:hover {
  background: #257EFE;
  color: #FFFFFF;
  border: 1px solid transparent;
}
</style>
